import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
const QueryManagement = () => {
  const { sidebar } = useContext(AppContext);

  useEffect(() => {
    $(document).ready(function () {
      let table;
      if ($.fn.dataTable.isDataTable("#table_user")) {
        table = $("#table_user").DataTable();
      } else {
        table = $("#table_user").DataTable({
          ordering: false,

          language: {
            search: "",
            searchPlaceholder: "Search...",
            sLengthMenu: "Entries per page _MENU_",
          },
        });
      }
    });
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [deleteShow, setDeleteShow] = useState(false);
  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = () => setDeleteShow(true);

  const [viewShow, setViewShow] = useState(false);
  const handleViewClose = () => setViewShow(false);
  const handleViewShow = () => setViewShow(true);

  const [validated, setValidated] = useState(false);
  console.log("first", validated);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Query Management</label>
        </div>
        <div className="add-btn"></div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>USER ID CARD VERIFICATION</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row user-detail">
            <div className="col-3 ">
              <label htmlFor="">Full Name:</label>
            </div>
            <div className="col-3 ">
              <span>Ramakant </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-3 ">
              <label htmlFor="">Email :</label>
            </div>
            <div className="col-3 ">
              <span>ramakant@gmail.com </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-3 ">
              <label htmlFor="">Date of Birth :</label>
            </div>
            <div className="col-3 ">
              <span>29-Dec-2022 </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-3 ">
              <label htmlFor="">ID Card :</label>
            </div>
            <div className="col-3 ">
              <span>NA </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttons-modal    ">
            <button className="me-2 " type="submit" onClick={handleClose}>
              Cancel
            </button>
            <button className=" " type="submit">
              Verify User
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={viewShow}
        onHide={handleViewClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>QUERY DETAILS</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">User Name :</label>
            </div>
            <div className="col-md-9 ">
              <span>Mangesh </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Email :</label>
            </div>
            <div className="col-md-9 ">
              <span>ramakant@gmail.com </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Phone Number :</label>
            </div>
            <div className="col-md-9 ">
              <span>NA</span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Title :</label>
            </div>
            <div className="col-md-9 ">
              <span>sdavdszgdfzs</span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Message :</label>
            </div>
            <div className="col-md-9 ">
              <span>fdshxfdhthh </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Date and Time :</label>
            </div>
            <div className="col-md-9 ">
              <span>July 05 2022, 06:28 PM</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={deleteShow}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Do you want to delete?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 "
              type="submit"
              style={{ backgroundColor: "red" }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="table-wrapper">
        <table id="table_user" class="display">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Title</th>
              <th>Date & Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>admin</td>
              <td>admin@gmail.com</td>
              <td>8975648972</td>
              <td>test</td>
              <td className="action">
                <Link to="#" className="icon" onClick={handleViewShow}>
                  <img src={ic_eyes} alt="" />
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  );
};

export default QueryManagement;
